var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrabbing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 25,
    fill: "none",
    viewBox: "0 0 23 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.344 5.823a2.03 2.03 0 0 1 1.406-.573c.747 0 1.403.414 1.778 1.039A2 2 0 0 1 14.562 6c.627 0 1.19.291 1.576.754 1.863.095 3.346 1.736 3.346 3.746v1.758a8.679 8.679 0 0 1-1.019 4.093l-1.278 2.387c-.501.935-1.433 1.512-2.442 1.512H9.32c-.908 0-1.76-.468-2.289-1.256l-2.099-3.135a5.492 5.492 0 0 1-.916-3.051V10.5c0-1.853 1.26-3.392 2.915-3.696C7.205 5.902 8 5.25 8.937 5.25c.54 0 1.034.217 1.407.573Z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E2B32",
    fillRule: "evenodd",
    d: "M10.344 5.823a2.03 2.03 0 0 1 1.406-.573c.747 0 1.403.414 1.778 1.039A2 2 0 0 1 14.562 6c.627 0 1.19.291 1.576.754 1.863.095 3.346 1.736 3.346 3.746v1.758a8.679 8.679 0 0 1-1.019 4.093l-1.278 2.387c-.501.935-1.433 1.512-2.442 1.512H9.32c-.908 0-1.76-.468-2.289-1.256l-2.099-3.135a5.492 5.492 0 0 1-.916-3.051V10.5c0-1.853 1.26-3.392 2.915-3.696C7.205 5.902 8 5.25 8.937 5.25c.54 0 1.034.217 1.407.573ZM9.64 7.5v.75c0 .414.314.75.703.75.388 0 .703-.336.703-.75V7.5c0-.414.315-.75.703-.75.388 0 .703.336.703.75v.75c0 .414.315.75.703.75.389 0 .703-.336.703-.75s.315-.75.704-.75c.388 0 .703.336.703.75V9c0 .414.314.75.703.75.388 0 .703-.336.703-.75v-.622c.82.309 1.406 1.142 1.406 2.122v1.758a7.102 7.102 0 0 1-.834 3.35l-1.278 2.386c-.25.468-.717.756-1.221.756H9.32c-.454 0-.88-.234-1.144-.628l-2.1-3.134a3.923 3.923 0 0 1-.654-2.18V10.5c0-.98.587-1.813 1.406-2.122v2.872c0 .414.315.75.703.75.389 0 .703-.336.703-.75V7.5c0-.414.315-.75.704-.75.388 0 .703.336.703.75Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 21.469,
    height: 21,
    x: 1.016,
    y: 3.75,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_96360_46138"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_96360_46138",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrabbing);
export default __webpack_public_path__ + "static/media/Grabbing.18161cb8246edb303f53ffde4dcc6390.svg";
export { ForwardRef as ReactComponent };